export default __webpack_public_path__ + "static/media/Shot_32.0000.35c4c66e.png";